import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicWidgetProperties } from 'book-widgets/interfaces';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';
import { render_topic_content } from '../../support/utils';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const HeroBanner = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);

	return v('div', { classes: [themeCss.heroBanner, ...additionalClasses] }, render_topic_content(topicdata));
});
